import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Menu, X, User, LogOut } from 'lucide-react';
import Button from './Button';
import { useAuth } from '@/context/AuthContext';
import { toast } from 'sonner';

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { user, signOut, isAdmin } = useAuth();
  const navigate = useNavigate();
  
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };
  
  const handleSignOut = async () => {
    try {
      await signOut();
      navigate('/');
      toast.success('You have been signed out successfully');
    } catch (error) {
      console.error('Sign out error:', error);
      toast.error('Failed to sign out. Please try again.');
    }
  };
  
  return (
    <header className="bg-omoduduwa-indigo shadow-md sticky top-0 z-50">
      <div className="container-custom py-3 bg-zinc-950">
        <div className="flex items-center justify-between">
          <Link to="/" className="flex items-center space-x-2">
            
          </Link>

          {/* Desktop Nav */}
          <nav className="hidden md:flex space-x-6">
            <Link to="/" className="font-medium text-white hover:text-omoduduwa-terracotta transition-colors">
              Home
            </Link>
            <Link to="/about" className="font-medium text-white hover:text-omoduduwa-terracotta transition-colors">
              About Us
            </Link>
            <Link to="/mission" className="font-medium text-white hover:text-omoduduwa-terracotta transition-colors">
              Our Mission
            </Link>
            <Link to="/get-involved" className="font-medium text-white hover:text-omoduduwa-terracotta transition-colors">
              Get Involved
            </Link>
            <Link to="/news" className="font-medium text-white hover:text-omoduduwa-terracotta transition-colors">
              News & Updates
            </Link>
            <Link to="/resources" className="font-medium text-white hover:text-omoduduwa-terracotta transition-colors">
              Resources
            </Link>
            <Link to="/statement-generator" className="font-medium text-white hover:text-omoduduwa-terracotta transition-colors">
              Statement Generator
            </Link>
            <Link to="/contact" className="font-medium text-white hover:text-omoduduwa-terracotta transition-colors">
              Contact Us
            </Link>
          </nav>

          <div className="hidden md:flex items-center space-x-4">
            {user ? (
              <div className="flex items-center space-x-4">
                <Link to="/community">
                  <Button variant="outline" size="sm" className="text-slate-50">
                    <User size={16} className="mr-2" /> Community
                  </Button>
                </Link>
                {isAdmin && (
                  <Link to="/admin">
                    <Button variant="outline" size="sm" className="text-slate-50">
                      Admin
                    </Button>
                  </Link>
                )}
                <Button 
                  variant="text" 
                  size="sm" 
                  className="text-slate-50"
                  onClick={handleSignOut}
                >
                  <LogOut size={16} className="mr-2" /> Sign Out
                </Button>
              </div>
            ) : (
              <Link to="/join">
                <Button variant="outline" size="sm" className="text-slate-50">
                  Join Us
                </Button>
              </Link>
            )}
          </div>

          {/* Mobile menu button */}
          <button onClick={toggleMenu} className="md:hidden p-2 focus:outline-none text-white" aria-label="Toggle menu">
            {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {/* Mobile Nav */}
      {isMenuOpen && (
        <div className="md:hidden bg-white border-t">
          <div className="container-custom py-4">
            <nav className="flex flex-col space-y-4">
              <Link to="/" className="font-medium text-omoduduwa-indigo hover:text-omoduduwa-terracotta transition-colors" onClick={toggleMenu}>
                Home
              </Link>
              <Link to="/about" className="font-medium text-omoduduwa-indigo hover:text-omoduduwa-terracotta transition-colors" onClick={toggleMenu}>
                About Us
              </Link>
              <Link to="/mission" className="font-medium text-omoduduwa-indigo hover:text-omoduduwa-terracotta transition-colors" onClick={toggleMenu}>
                Our Mission
              </Link>
              <Link to="/get-involved" className="font-medium text-omoduduwa-indigo hover:text-omoduduwa-terracotta transition-colors" onClick={toggleMenu}>
                Get Involved
              </Link>
              <Link to="/news" className="font-medium text-omoduduwa-indigo hover:text-omoduduwa-terracotta transition-colors" onClick={toggleMenu}>
                News & Updates
              </Link>
              <Link to="/resources" className="font-medium text-omoduduwa-indigo hover:text-omoduduwa-terracotta transition-colors" onClick={toggleMenu}>
                Resources
              </Link>
              <Link to="/statement-generator" className="font-medium text-omoduduwa-indigo hover:text-omoduduwa-terracotta transition-colors" onClick={toggleMenu}>
                Statement Generator
              </Link>
              <Link to="/contact" className="font-medium text-omoduduwa-indigo hover:text-omoduduwa-terracotta transition-colors" onClick={toggleMenu}>
                Contact Us
              </Link>
              
              {user ? (
                <>
                  <Link to="/community" className="font-medium text-omoduduwa-indigo hover:text-omoduduwa-terracotta transition-colors" onClick={toggleMenu}>
                    Community
                  </Link>
                  {isAdmin && (
                    <Link to="/admin" className="font-medium text-omoduduwa-indigo hover:text-omoduduwa-terracotta transition-colors" onClick={toggleMenu}>
                      Admin Dashboard
                    </Link>
                  )}
                  <Button 
                    variant="text" 
                    size="sm"
                    className="justify-start text-omoduduwa-indigo hover:text-omoduduwa-terracotta"
                    onClick={() => {
                      handleSignOut();
                      toggleMenu();
                    }}
                  >
                    <LogOut size={16} className="mr-2" /> Sign Out
                  </Button>
                </>
              ) : (
                <Link to="/join" className="mt-2" onClick={toggleMenu}>
                  <Button variant="primary" size="sm" fullWidth>
                    Join Us
                  </Button>
                </Link>
              )}
            </nav>
          </div>
        </div>
      )}
    </header>
  );
};

export default Navbar;
